<template>
  <card
    :padding="24"
    dis-hover
    class="profile-block-card profile-notifications"
  >
    <div class="card-header large">
      <div class="card-header__title">
        <icon class="ms-help" size="16" type="md-notifications"></icon>
        <span class="ms-help card-header__title-text"
          >Настройка уведомлений</span
        >
      </div>
    </div>
    <div class="profile-notifications__container">
      <i-form
        ref="changePasswordForm"
        :model="currentInfo"
        label-position="left"
        :label-width="160"
      >
        <form-item label="Веб-платформа" prop="last_name">
          <i-switch v-model="currentInfo.system_notify" size="large">
            <span slot="open">Вкл</span>
            <span slot="close">Откл</span>
          </i-switch>
        </form-item>
        <form-item label="Telegram" prop="last_name">
          <i-switch v-model="currentInfo.telegram_notify" size="large">
            <span slot="open">Вкл</span>
            <span slot="close">Откл</span>
          </i-switch>
          <template v-if="!user.telegram_chat_id">
            <i-button
              v-if="!telegramMessage"
              class="ms-link get-telegram-link"
              type="text"
              @click="getTelegramLink"
            >
              Получить параметры авторизации для Telegram
            </i-button>
            <span v-else class="telegram-info ms-small-head ms-link">{{
              telegramMessage
            }}</span>
          </template>
        </form-item>
        <form-item>
          <i-button
            size="default"
            type="primary"
            @click="changeNotifications"
            :loading="loading"
            >Сохранить</i-button
          >
        </form-item>
      </i-form>
    </div>
  </card>
</template>

<script>
const notificationsFields = ['system_notify', 'mail_notify', 'telegram_notify']

export default {
  data () {
    return {
      currentInfo: {
        system_notify: false,
        mail_notify: false,
        telegram_notify: false
      },
      telegramMessage: '',
      loading: false
    }
  },
  computed: {
    user () {
      return this.$store.state.auth.user
    }
  },
  methods: {
    async changeNotifications () {
      try {
        this.loading = true
        const url = `objectInfo/users`
        const data = { id: this.user.id, ...this.currentInfo }
        await this.$store.dispatch('POST_REQUEST', { url, data })
        this.$store.commit('SET_USER_INFO', this.currentInfo)
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
        this.$Message.error(
          'Произошла ошибка при сохранении настроек уведомлений'
        )
      }
    },
    async getTelegramLink () {
      try {
        const url = `/page/telegram_url`
        const { bot_name, command } = await this.$store.dispatch(
          'GET_REQUEST',
          { url }
        )
        this.telegramMessage = `Название бота - ${bot_name}. Команда авторизации - ${command}`
      } catch (error) {
        console.log(error)
      }
    }
  },
  created () {
    notificationsFields.forEach(f => (this.currentInfo[f] = this.user[f]))
  }
}
</script>

<style lang="less">
.profile-notifications {
  .ivu-form-item:last-child {
    margin-bottom: 0;
  }

  .get-telegram-link {
    margin-left: 16px;
    color: lighten(@primary-color, 15%);
  }

  .telegram-info {
    margin-left: 24px;
    line-height: 24px;
  }
}
</style>
